import Resource from './Resource';

export default class ClassPageDetails extends Resource {
	constructor(options={}) {
		let {
			routeParams = {},
			query = {}
		} = options;

		let config = {
			route: 'class-pages/:courseSectionGuid/details',
			query: query,
			routeParams: routeParams,
		};
		super(config);
		return this;
	}

	get() {
		return this.request();
	}
}
